export const QueryKeys = {
    Extra: 'extra',
    ExtraPaid: 'extraPaid',
    moduleType: 'moduleType',
    ConfigureFreeSignup: 'configure-free-signup'
};
